export const UPDATE_KYC_STATE_SUCCESS = "UPDATE_KYC_STATE_SUCCESS";
export const UPDATE_KYC_STATE_REQUEST = "UPDATE_KYC_STATE_REQUEST";
export const UPDATE_KYC_STATE_FAILURE = "UPDATE_KYC_STATE_FAILURE";
export const UPDATE_KYC_STATE_RESET = "UPDATE_KYC_STATE_RESET";
export const updateKYCstateSuccess = (payload) => ({
    type: UPDATE_KYC_STATE_SUCCESS,
    payload,
});
export const updateKYCstateRequest = (payload) => ({
    type: UPDATE_KYC_STATE_REQUEST,
    payload,
});
export const updateKYCstateFailure = (payload) => ({
    type: UPDATE_KYC_STATE_FAILURE,
    payload,
});
export const updateKYCstateReset = () => ({
    type: UPDATE_KYC_STATE_RESET,
});
